/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { PureComponent } from 'react'
import { Form } from 'semantic-ui-react'
import TimePicker from 'rc-time-picker'
import moment from 'moment'

export default class TimeField extends PureComponent {
  render() {
    const { label, value, onChange } = this.props

    return (
      <Form.Field required>
        <label>{label}</label>
        <TimePicker
          style={{ display: 'flex', flex: 1 }}
          className="time-field-input-height"
          showSecond={false}
          value={moment(value)}
          onChange={m => m && onChange(m)}
          format="hh:mm A"
          use12Hours
          inputReadOnly
        />
      </Form.Field>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/serviceAvailability/components/TimePicker.js